import { Box, Stack, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

function CartShippingNotice() {
  const { t } = useTranslation(['cart']);

  return (
    <Box
      mt={3}
      pt={3}
      borderTop="1px solid"
      borderColor="blackAlpha.400"
    >
      <Stack spacing={3}>
        <Text fontSize="sm" lineHeight="1.45" color="gray.700">
          {t('cart.shippingNotice.standard')}
        </Text>

        <Box>
          <Text
            as="strong"
            display="block"
            fontSize="sm"
            fontWeight={700}
            lineHeight="1.45"
            color="gray.700"
            mb={1}
          >
            {t('cart.shippingNotice.largeItemTitle')}
          </Text>
          <Text fontSize="sm" lineHeight="1.45" color="gray.700">
            {t('cart.shippingNotice.largeItem')}
          </Text>
        </Box>
      </Stack>
    </Box>
  );
}

export default CartShippingNotice;
